// extracted by css-extract-rspack-plugin
export default {"baseLink":"WaGKI","disabled":"yWovp"};